import { z } from 'zod';
/** Workspace roles (brief: Identity and access → Roles and permissions). */
export const Role = z.enum(['owner', 'admin', 'member', 'guest']);
export const MAX_OWNERS = 5;
//# sourceMappingURL=roles.js.map